import Swal from 'sweetalert2'
import moment from 'moment'
import { VueMaskDirective } from 'v-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import DetailTransaction from '@/components/detailTransaction.vue';
import GetStatusInTable from '@/components/GetStatusInTable.vue';
import CryptoJS from "crypto-js";

export default {
    data() {
        return {
            get API_URL() {
                return process.env.VUE_APP_STATUS == 'DEV' ? process.env.VUE_APP_API_DEV : process.env.VUE_APP_API_PRODUCTION
            },
            currencyMask: createNumberMask({
                // allowDecimal: true,
                includeThousandsSeparator: true,
                allowNegative: false,
                prefix: '',
                thousandsSeparatorSymbol: '.',
            })
        }
    },
    components: {
        DetailTransaction,
        GetStatusInTable
    },
    computed: {
        companyType() {
            return this.$store.state.userData.company_type.code
        },
        userType() {
            return this.$store.state.userData.role_name
        }
    },
    methods: {
        notAfterToday(date) {
            return date > new Date(new Date().setHours(0, 0, 0, 0));
        },
        encryptData(data){
            if(data){
                let iv = CryptoJS.lib.WordArray.random(16),
                key = CryptoJS.enc.Base64.parse(process.env.VUE_APP_KEY);
                let options = {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                };
                let encrypted = CryptoJS.AES.encrypt(data, key, options);
                encrypted = encrypted.toString();
                iv = CryptoJS.enc.Base64.stringify(iv);
                let result = {
                    iv: iv,
                    value: encrypted,
                    mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString()
                }
                result = JSON.stringify(result);
                result = CryptoJS.enc.Utf8.parse(result);
                return CryptoJS.enc.Base64.stringify(result);
            }else{
                return null
            }
        },
        paymentMethodName(name){
            if(name == 'BPD'){
                return 'BPD Bali'
            }else if(name == 'QRIS'){
                return 'QRIS'
            }else if(name == 'QRIS_STATIC'){
                return 'QRIS Static'
            }else if(name == 'TUNAI'){
                return 'Tunai'
            }
        },
        sAlert(type, message) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3500,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                },
                icon: type,
                text: message
            })
        },
        // REINTEGER
        reInteger(val){
            if(val){
                const number = String(val).replace(/\./g, '')
                return parseInt(number)
            }else{
                return parseInt(val)
            }
        },
        currency(thenumber) {
            const priceString = String(thenumber)
            return 'Rp. ' + priceString.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        },
        dateFormat(date) {
            return moment(date).format('DD/MM/YYYY - H:m:s')
        },
        convertDate(date) {
            const dateString = String(date).split('/').join('-')
            return moment(dateString, 'DD-MM-YYYY').format('YYYY-MM-DD H:m:s')
            // return moment(date, ).format('YYYY-MM-DD')
        },
        convertSentDate(date){
            return moment(date).format('YYYY-MM-DD')
        },
        convertSentDateSlash(date){
            return moment(date).format('DD/MM/YYYY')
        },
        slugify(text) {
            return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
        },
        numberFormat(index) {
            if(index < 10){
                return '0'+index
            }else{
                return index
            }
        },
        dataTableSearch(){
            var table

            $('#table-default thead tr').clone(true).appendTo( '#table-default thead' );
            $('#table-default thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input type="text" placeholder="Cari '+title+'" />' );

                $( 'input', this ).on( 'keyup change', function () {
                    console.log(this);
                    
                    if ( table.column(i).search() !== this.value ) {
                        table
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );

            // $('#table-default').DataTable().destroy()

            table = $('#table-default').DataTable( {
                order: [],
                searching: true,
                orderCellsTop: true,
                fixedHeader: true,
                lengthChange: false
            });
        },

        validationImage(image) {
            const fileType = image['type']
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            if (!validImageTypes.includes(fileType)) {
                this.sAlert('error', 'Tolong masukkan file dengan format jpg, jpeg, atau png!')
                return true
            }

            if(image['size'] > 5e6){
                this.sAlert('error', 'Maximum file upload adalah 5MB')
                return true
            }
        },

        errorHandler(error) {
            if(error.response) {
                if(error.response.data.code){
                    if(error.response.data.code == 409){
                        this.sAlert('error', error.response.data.message);
                        return
                    }
                    if(error.response.data.code == 500){
                        this.sAlert('error', error.response.data.message);
                        return
                    }else{
                        this.sAlert('error', error.response.data.message);
                        return
                    }
                }
            }else{
                this.sAlert('error', 'Error, Terjadi Kesalahan!');
                return
            }
        }
    },
    directives: {
        select2: {
            inserted(el) {
                $(el).on('select2:select', () => {
                    const event = new Event('change', { bubbles: true, cancelable: true });
                    el.dispatchEvent(event);
                });

                $(el).on('select2:unselect', () => {
                    const event = new Event('change', {bubbles: true, cancelable: true})
                    el.dispatchEvent(event)
                })
            },
        },
        currency: VueMaskDirective
    }
}